import { all, takeEvery } from "@redux-saga/core/effects";
import { OPEN_SOCKET_CONNECTION, SOCKET_PAYMENT_SUBSCRIBER } from "../actions/actionTypes";
import { paymentRequestSubscriber, sailsWebSocketConnections } from "./integrations";

export function* watchApp() {
	yield all([
        takeEvery(OPEN_SOCKET_CONNECTION, sailsWebSocketConnections),
        takeEvery(SOCKET_PAYMENT_SUBSCRIBER, paymentRequestSubscriber)
    ])
}